import Multiselect from 'vue-multiselect';
import UserCard from '@/shared/user-card/index.vue';

// @vue/component
export default {
  name: 'multiselect-field',

  props: {
    options: {
      type: Array,
    },
    value: {
      type: [Array, Object],
    },
    placeholder: {
      type: String,
      default: 'Select Program(s)',
    },
    optionType: {
      type: String,
      default: 'userCard',
    },
    customTheme: {
      type: String,
      default: '',
    },
    openDirection: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideSelected: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    selected: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit('input', newValue);
      },
    },
  },

  components: {
    Multiselect,
    UserCard,
  },
};
